<template>
  <div class="page-container">
    <div class="left-side">
      <img class="image" src="../../assets/img/carbon/woshou.jpg" alt="示例图片" />
      <p class="quote">{{ $t('company.quote') }}</p>
      <p class="author">{{ $t('company.quote_2') }}</p>
    </div>
    <div class="right-side">
      <h2 class="title">{{ $t('company.coreTech.title') }}</h2>
      <p class="description">{{ $t('company.coreTech.description') }}</p>
      <!-- <button class="cta-button">{{ $t('company.learnMore') }}</button> -->
      <h2 class="title" style="margin-top: 50px;">{{ $t('company.enterprise.title') }}</h2>
      <p class="description">{{ $t('company.enterprise.description') }}</p>
      <!-- <button class="cta-button">{{ $t('company.learnMore') }}</button> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyIntro'
}
</script>

<style scoped>
.page-container {
  display: flex;
  justify-content: center; /* 居中显示两边内容 */
  padding: 80px; /* 减少容器的内边距 */
  background-color: #fff;
  flex-wrap: wrap; /* 使左右部分能在小屏幕上自动换行 */
}

.left-side,
.right-side {
  width: 40%; /* 减小左右部分的宽度，使它们更加紧凑 */
  margin: 0 30px; /* 增加左右部分之间的间隔 */
}

.image {
  width: 30%;
  height: auto;
  border-radius: 8px;
  margin-left: 250px;
}

.quote {
  font-style: italic;
  margin-top: 20px;
  font-size: 18px; /* 设置一个合适的字体大小 */
  line-height: 1.6; /* 增加行间距，让文本更易阅读 */
}

.author {
  margin-top: 30px;
  font-weight: bold;
  font-size: 26px;
  color: #004b8d;
}

.title {
  font-size: 40px;
  font-weight: bold;
  font-family: Microsoft JhengHei;
  margin-top: 20px;
}

.description {
  margin-top: 20px;
  font-size: 21px;
  font-family: Microsoft YaHei;
}

.cta-button {
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.cta-button:hover {
  background-color: #0056b3;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .page-container {
    padding: 10px; /* 进一步减少容器的内边距 */
  }

  .left-side,
  .right-side {
    width: 100%; /* 使左右部分占满屏幕宽度 */
    margin-bottom: 20px; /* 使两个部分之间有间隔 */
  }

  .quote {
    font-size: 16px; /* 缩小引用文字的字体大小 */
    line-height: 1.4; /* 调整行间距 */
  }

  .author {
    font-size: 14px; /* 缩小作者名字的字体 */
    margin-top: 8px; /* 调整作者信息与引用的间距 */
  }

  .title {
    font-size: 20px; /* 缩小标题字体 */
  }

  .description {
    font-size: 14px; /* 缩小描述文字 */
  }

  .cta-button {
    padding: 8px 16px; /* 缩小按钮的内边距 */
    font-size: 0.8rem;
    margin-top: 1rem;
  }
  .image{
    margin-left: 9rem
  }
}
</style>
